/* eslint-disable */
import React, { Component } from "react";
import { Form, Button, Grid, Input } from "semantic-ui-react";
import { getOcupacoes, getEstados, getConselhos } from "@store/actions/index";
import { selectFieldStyle } from "@utils/const";
import ErrorMsgLabel from "../shared/errorMsgLabel";
import { connect } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import m from "@utils/strings";
import "@styles/profissionais-executantes.css";
import { bindActionCreators } from "redux";

class FormFiltro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ocupacoes: [],
      ocupacaoSelecionada: null,
      estados: [],
      estadoSelecionado: null,
      conselhos: [],
      conselhoSelecionado: null,
      numeroConselho: "",
      nomeProfissional: "",
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.props.focusFirstField(this.focus);

    this.loadInputDatas();
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  componentDidUpdate() {
    console.table();
  }

  loadInputDatas = () => {
    this.props.getOcupacoes((result) => {
      let ocupacoes = result.data.map((ocupacao) => {
        return {
          Descricao: ocupacao.Descricao,
          Id: ocupacao.Id,
        };
      });
      this.setState({ ocupacoes });
    });
    this.props.getEstados((result) => {
      let estados = result.data.map((estado) => {
        return estado.Descricao;
      });
      this.setState({ estados });
    });
    this.props.getConselhos((result) => {
      let conselhos = result.data.map((conselho) => {
        return {
          descricao: conselho.Descricao,
          id: conselho.id,
        };
      });
      this.setState({ conselhos });
    });
  };

  ocupacaoSelect = (event) => {
    this.setState({ ocupacaoSelecionada: event });
  };

  estadoSelect = (event) => {
    this.setState({ estadoSelecionado: event });
  };

  conselhoSelect = (event) => {
    this.setState({ conselhoSelecionado: event });
  };

  handleKeyDown(event) {
    if (event.key === "Enter" && this.props.activeAccordion == "1") {
      event.preventDefault();
      this.handleSubmit();
    }
  }

  handleInputStateValue = (event, { name, value }) => {
    const { nomeProfissional, numeroConselho } = this.state;
    if (name == "nomeProfissional" && value.length > 70)
      value = nomeProfissional;
    else if (name == "numeroConselho" && value.length > 15)
      value = numeroConselho;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const {
      ocupacaoSelecionada,
      estadoSelecionado,
      conselhoSelecionado,
      nomeProfissional,
      numeroConselho,
      ocupacoes,
    } = this.state;
    let params = {};
    let stop = false;

    !_.isEmpty(estadoSelecionado)
      ? (params.estado = estadoSelecionado.label)
      : {};
    !_.isEmpty(nomeProfissional) ? (params.nome = nomeProfissional) : {};
    !_.isEmpty(numeroConselho) ? (params.numeroConselho = numeroConselho) : {};

    if (!_.isEmpty(ocupacaoSelecionada)) {
      let getIdOcupacaoSelecionada = null;
      for (let i = 0, stop = false; i < ocupacoes.length && !stop; i++) {
        if (ocupacaoSelecionada.value == ocupacoes[i].descricao) {
          getIdOcupacaoSelecionada = ocupacoes[i].id;
          stop = true;
        }
      }
      getIdOcupacaoSelecionada
        ? (params.idOcupacao = getIdOcupacaoSelecionada)
        : {};
    }

    if (!_.isEmpty(conselhoSelecionado)) {
      let getIdConselhoSelecionado = null;
      for (let i = 0, stop = false; i < this.state.conselhos.length && !stop; i++) {
        if (conselhoSelecionado.value == this.state.conselhos[i].descricao) {
          getIdConselhoSelecionado = this.state.conselhos[i].id;
          stop = true;
        }
      }
      getIdConselhoSelecionado
        ? (params.idConselho = getIdConselhoSelecionado)
        : {};
    }
    this.props.applyFilter(params);
  };

  focus = () => {
    setTimeout(() => {
      if (this.textInput) this.textInput.focus();
    }, 1000);
  };

  render() {
    return (
      <div>
        <Form>
          <div id="label-buscar">
            {" "}
            {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_BUSCAR_POR}
          </div>
          <Form.Group id="form-group">
            <Form.Field inline={true} width={5}>
              <div className="form-input-label">
                {
                  m.TELA_PROFISSIONAIS_EXECUTANTES
                    .LABEL_NOME_PROFISSIONAL_SOLICITANTE
                }
              </div>
              <Input
                name="nomeProfissional"
                value={this.state.nomeProfissional}
                onChange={this.handleInputStateValue}
                ref={(input) => {
                  this.textInput = input;
                }}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field inline={true} width={5}>
              <div className="form-input-label">
                {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OCUPACAO}
              </div>
              <Select
                value={this.state.ocupacaoSelecionada}
                onChange={this.ocupacaoSelect}
                placeholder=""
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return m.TELA_PROFISSIONAIS_EXECUTANTES
                    .MENSAGEM_NENHUMA_OCUPACAO_ENCONTRADA;
                }}
                styles={selectFieldStyle}
                options={this.state.ocupacoes.map((ocupacao) => {
                  return {
                    value: ocupacao.Descricao,
                    label: `${ocupacao.Id} - ${ocupacao.Descricao}`,
                  };
                })}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field inline={true} width={2}>
              <div className="form-input-label">
                {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_CONSELHO}
              </div>
              <Select
                value={this.state.conselhoSelecionado}
                onChange={this.conselhoSelect}
                placeholder=""
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return m.TELA_PROFISSIONAIS_EXECUTANTES
                    .MENSAGEM_NENHUM_CONSELHO_ENCONTRADO;
                }}
                styles={selectFieldStyle}
                options={this.state.conselhos.map((conselho) => {
                  return {
                    value: conselho.descricao,
                    label: conselho.descricao,
                  };
                })}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field inline={true} width={3}>
              <div className="form-input-label">
                {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_NUMERO_CONSELHO}
              </div>
              <Form.Input
                name="numeroConselho"
                value={this.state.numeroConselho}
                onChange={this.handleInputStateValue}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field inline={true} width={2}>
              <div className="form-input-label">
                {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_ESTADO}
              </div>
              <Select
                value={this.state.estadoSelecionado}
                onChange={this.estadoSelect}
                placeholder=""
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return m.TELA_PROFISSIONAIS_EXECUTANTES
                    .MENSAGEM_NENHUM_ESTADO_ENCONTRADO;
                }}
                styles={selectFieldStyle}
                options={this.state.estados.map((estado) => {
                  return { value: estado, label: estado };
                })}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_OBRIGATORIO}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group id="form-group">
            <Form.Field inline={true} width={12} />
            <Form.Field inline={true} width={4}>
              <Button
                className="button-filtrar-profissionais"
                onClick={this.handleSubmit}
              >
                {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_FILTRAR} (ENTER)
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getOcupacoes, getEstados, getConselhos }, dispatch);
}

export default connect(null, mapDispatchToProps)(FormFiltro);
